import React from "react";
import { Container, Typography, Box, Paper, Grid } from "@mui/material";

function YogaContent() {
  return (
    <Container maxWidth="md" sx={{ my: 4,mt:10 }}>
      {/* Main Title */}
      <Typography
        variant="h2"
        component="h1"
        align="center"
        gutterBottom
        sx={{ fontWeight: 500, color: "#2D3748", fontFamily: "poppins" }}
      >
        The Self and Consciousness
      </Typography>

      {/* Introduction Section */}
      <Paper elevation={0} sx={{ p: 4, mb: 4,border:"1px solid",borderColor:"grey.300" }}>
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#2D3748" }}
        >
          The Interplay of Mind, Body, and Consciousness
        </Typography>
        <Typography variant="body1" sx={{fontFamily:"poppins",mb:1}} textAlign={"start"}>
          The self or consciousness exists in the pool of continuous
          communication between the mind and body. The consciousness is buried
          within these two phenomena. Over time, the self or consciousness,
          which is a witness, slowly loses its grip as a witness and becomes
          moved and controlled by the body and mind.
        </Typography>
        <Typography variant="body1" sx={{fontFamily:"poppins",mb:1}}  textAlign={"start"}>
          For example, when we whirl continually in a place, before we begin to
          whirl, we know we are not the whirl nor the act of whirling. But as we
          whirl and continue for a number of turns, we may notice that we are
          lost in the whirl for a while. The mind accepts, for the moment, that 
          we are the whirl and is unable to think otherwise.
        </Typography>
        <Typography variant="body1" sx={{fontFamily:"poppins",mb:1}}  textAlign={"start"}>
          The same is the case with consciousness: in the whirl of body and
          mind, we are assumed to be the whirl.
        </Typography>
      </Paper>

      {/* Yoga's Approach Section */}
      <Paper elevation={0} sx={{ p: 4, mb: 4,border:"1px solid",borderColor:"grey.300" }}>
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          sx={{ fontWeight: "bold", color: "text.secondary" }}
        >
          Yoga's Approach: From Body to Mind
        </Typography>
        <Typography variant="body1" sx={{fontFamily:"poppins",mb:1}} textAlign={"start"}>
          Yoga's approach is to move from the body to the mind. The body, in
          certain aspects, controls the mind. For example, dull and gloomy
          weather can lead to unreasonable depression in some individuals. This
          is not caused by the mind but by the body.
        </Typography>
        <Typography variant="body1" sx={{fontFamily:"poppins",mb:1}} textAlign={"start"}>
          To address this, yoga begins by ensuring that the mind is not
          influenced by the body's desires. This is achieved through{" "}
          <strong>yoga asanas</strong>, <strong>kriyas</strong>, and{" "}
          <strong>pranayama</strong>, which remove the first veil caused by the
          body. Once the body's influence is minimized, the mind acts freely.
        </Typography>
        <Typography variant="body1" sx={{fontFamily:"poppins",mb:1}} textAlign={"start"}>
          Next, to control the mind, yoga employs <strong>dharana</strong>{" "}
          (concentration) and <strong>dhyana</strong> (meditation). These
          practices help remove the second veil of the mind over the self. Once
          both veils are removed, the unveiled self is revealed, a state known
          as <strong>samadhi</strong>.
        </Typography>
      </Paper>

      {/* Key Concepts Section */}
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid item xs={12} md={6}>
        <Paper elevation={0} sx={{ p: 4, mb: 4,border:"1px solid",borderColor:"grey.300" ,height:"250px"}}>
            <Typography 
              variant="h6"
              component="h3"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#2D3748" ,fontFamily:"poppins"}}
            >
              The Two Veils
            </Typography>
            <Typography variant="body1"    textAlign={"start"} sx={{mb:2,fontFamily:"poppins"}}>
              <strong>1. The Body's Veil:</strong> The body influences the mind
              through desires and sensations. Yoga asanas, kriyas, and pranayama
              help remove this veil.
            </Typography>
            <Typography variant="body1"  sx={{fontFamily:"poppins"}}  textAlign={"start"} >
              <strong>2. The Mind's Veil:</strong> The mind creates thoughts,
              emotions, and distractions. Dharana and dhyana help remove this
              veil.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
        <Paper elevation={0} sx={{ p: 4, mb: 4,border:"1px solid",borderColor:"grey.300",height:"250px" }}>
            <Typography
              variant="h6"
              component="h3"
              gutterBottom
           
              sx={{ fontWeight: "bold", color: "#2D3748",fontFamily:"poppins"}}
            >
              The Unveiled Self
            </Typography>
            <Typography variant="body1"   sx={{fontFamily:"poppins"}}   textAlign={"start"}>
              When both veils are removed, the true self or consciousness is
              revealed. This state is called <strong>samadhi</strong>, where the
              self exists in its purest form, free from the influences of the
              body and mind.
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Final Note */}
      <Box sx={{ textAlign: "center", my: 4 }}>
        <Typography
          variant="h6"
          component="h3"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#2D3748" ,fontFamily:"poppins"}}
        >
          Embark on the Journey to Unveil Your True Self
        </Typography>
        <Typography variant="body1" sx={{fontFamily:"poppins"}}>
          Through the practice of yoga, one can gradually remove the veils of
          the body and mind, leading to the realization of the true self. Begin
          your journey today with mindful practices and meditation.
        </Typography>
      </Box>
    </Container>
  );
}

export default YogaContent;
